import React from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { ResponsiveLine } from '@nivo/line';
import { Sparklines, SparklinesLine, SparklinesSpots, SparklinesReferenceLine } from 'react-sparklines';

import { CustomContainer } from '../../common';
import { DEFAULT_DAYS_AGO } from '../../../constants';
import { formatDatetime } from '../../Utils';

const COLORS = {
  REPLIES: '#fbbd08',
  LIKES: '#2185d0',
  HATES: '#db2828',
};

const CHART_HEIGHT = 300;

const ActivitiesChart = ({ data, isMobile }) => {
  if (isMobile) {
    return (
      <div>
        <Sparklines data={data.map((e) => e.num_likes)}>
          <SparklinesLine color={COLORS.LIKES} />
          <SparklinesSpots />
          <SparklinesReferenceLine type="mean" />
        </Sparklines>
        <Sparklines data={data.map((e) => e.num_hates)}>
          <SparklinesLine color={COLORS.HATES} />
          <SparklinesSpots />
          <SparklinesReferenceLine type="mean" />
        </Sparklines>
        <Sparklines data={data.map((e) => e.num_replies)}>
          <SparklinesLine color={COLORS.REPLIES} />
          <SparklinesSpots />
          <SparklinesReferenceLine type="mean" />
        </Sparklines>
      </div>
    );
  }

  return (
    <div style={{ height: CHART_HEIGHT }}>
      <ResponsiveLine
        data={[{
          id: '推文',
          data: data.map((e) => ({
            x: formatDatetime(e.datetime),
            y: e.num_likes,
          })),
        }, {
          id: '噓文',
          data: data.map((e) => ({
            x: formatDatetime(e.datetime),
            y: e.num_hates,
          })),
        }, {
          id: '回文',
          data: data.map((e) => ({
            x: formatDatetime(e.datetime),
            y: e.num_replies,
          })),
        }]}
        enablePoints={false}
        colors={[COLORS.LIKES, COLORS.HATES, COLORS.REPLIES]}
        margin={{ top: 20, right: 110, bottom: 60, left: 50 }}
        xScale={{ type: 'point' }}
        yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          format: (e) => ['07', '14', '21', '28'].includes(e.split('-')[2]) && e,
          orient: 'bottom',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: -45,
        }}
        axisLeft={{
          format: (e) => Math.floor(e) === e && e,
          orient: 'left',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
        }}
        pointSize={10}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        pointLabelYOffset={-12}
        useMesh
        legends={[
          {
            anchor: 'bottom-right',
            direction: 'column',
            justify: false,
            translateX: 100,
            translateY: 0,
            itemsSpacing: 0,
            itemDirection: 'left-to-right',
            itemWidth: 80,
            itemHeight: 20,
            itemOpacity: 0.75,
            symbolSize: 12,
            symbolShape: 'circle',
            symbolBorderColor: 'rgba(0, 0, 0, .5)',
            effects: [
              {
                on: 'hover',
                style: {
                  itemBackground: 'rgba(0, 0, 0, .03)',
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
      />
    </div>
  );
};

export default (props) => {
  const {
    data,
    isFetching,
    isMobile,
  } = props;

  const hasData = (Array.isArray(data) && data.length > 0);

  return (
    <CustomContainer>
      <Header as={isMobile ? 'h3' : 'h2'} attached="top">
        <span style={{ color: COLORS.LIKES }}>推</span>
        {' '}
        /
        {' '}
        <span style={{ color: COLORS.HATES }}>噓</span>
        {' '}
        /
        {' '}
        <span style={{ color: COLORS.REPLIES }}>回</span>
        文趨勢 (
        {DEFAULT_DAYS_AGO / 30}
        個月之內)
      </Header>
      <Segment attached loading={isFetching}>
        {
          hasData ? (
            <ActivitiesChart
              data={data}
              isMobile={isMobile}
            />
          ) : <p>似乎潛水一陣子了呢...</p>
        }
      </Segment>
    </CustomContainer>
  );
};
